<template>
  <application-layout>
    <v-main>
      <v-container>
        <h1>Manage Users</h1>
        <v-dialog
          v-model="addUser"
          persistent
          max-width="600"
        >
          <template v-slot:activator ="{ on }">
            <v-btn
              data-testid="user-index-add-btn"
              class="user-index-add-btn mb-4 ml-0"
              v-on="on"
              color="primary"
            >
              <v-icon>add</v-icon>
              Add New User
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline">Add New User</v-card-title>
            <v-form
              ref="createUserForm"
              @submit.prevent="submitUserForm"
            >
              <v-card-text>
                <app-input
                  data-testid="user-index-email-input"
                  class="user-index-email-input"
                  label="Email Address"
                  v-model.trim="email"
                  :type="'email'"
                  :rules="{ required: true, email: true }"
                  :useValidation="true"
                />
                <v-alert
                  v-if="userCreateErrorMessage"
                  type="error"
                >
                  {{ userCreateErrorMessage }}
                </v-alert>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  data-testid="user-index-cancel-btn"
                  class="user-index-cancel-btn"
                  color="error"
                  @click="addUser = false"
                >
                  Cancel
                </v-btn>
                <v-spacer />
                <v-btn
                  data-testid="user-index-add-btn"
                  class="user-index-add-btn"
                  color="primary"
                  type="submit"
                  :loading="loading"
                  :disabled="loading"
                >
                  Add User
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        <v-data-table :headers="headers" :items="users">
          <template v-slot:body="{ items }">
            <transition-group
              name="scroll-y-transition"
              tag="tbody"
              v-if="items.length"
            >
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.id }}</td>
                <td>
                  <span v-if="item.registered">{{ item.username }}</span>
                  <span v-else class="error--text">N/A</span>
                </td>
                <td>
                  <span v-if="item.registered">{{ item.first_name}} {{ item.last_name }}</span>
                  <span v-else class="error--text">User has not finished registration</span>
                </td>
                <td>{{ item.email }}</td>
                <td>
                  <v-btn
                    data-testid="user-index-edit-btn"
                    class="user-index-edit-btn primary mr-3"
                    small
                    :to="{ name: 'usersEdit', params: { userId: item.id } }"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    data-testid="user-index-delete-btn"
                    class="user-index-delete-btn error"
                    small
                    @click="openDelete(item)"
                  >
                    Delete
                  </v-btn>
                </td>
              </tr>
            </transition-group>
            <tr v-else>
              <td colspan="12" style="text-align: center">
                No users found.
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-main>

    <delete-modal
      v-model="modal"
      @delete="deleteUser"
      :itemType="'user'"
      :advisory="advisory"
    />
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import { emailRules } from "@/helpers/form-rules";
import { genericAdvisory } from "@/helpers/warning-advisory-text";
import { userHeaders } from "@/helpers/user/user-data-table-headers";

export default {
  components: {
    ApplicationLayout,
    DeleteModal
  },
  data() {
    return {
      advisory: genericAdvisory,
      addUser: false,
      loading: false,
      email: "",
      emailRules: emailRules,
      deleteConfirm: false,
      headers: userHeaders,
      modal: false,
      selectedUser: ""
    };
  },
  methods: {
    submitUserForm() {
      if (this.$refs.createUserForm.validate()) {
        this.loading = true;
        this.$store.dispatch("createUser", { email: this.email })
          .then(() => {
            this.email = null;
            this.addUser = this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    openDelete(user) {
      this.selectedUser = user;
      this.modal = true;
    },

    async deleteUser() {
      await this.$store.dispatch("deleteUser", this.selectedUser.id);
      this.selectedUser = "";
      this.modal = false;
    }
  },
  computed: {
    users() {
      return this.$store.state.user.users;
    },
    userCreateErrorMessage() {
      return this.$store.getters.userCreateErrorMessage;
    }
  },
  created() {
    this.$store.dispatch("getAllUsers");
  }
};
</script>
